import { Link } from 'react-router-dom';

const Error = () => (
  <>
    <h1>Error Page.</h1>
    <p>
      <Link to="/">go back</Link>
    </p>
  </>
);

export default Error;
